import type {SendFile} from '../api/request'
import axios from 'axios'

export const secondsFromGMT = () => new Date().getTimezoneOffset() * 60
export const timestamp = () =>
  new Date().getTime() / 1000 + new Date().getTimezoneOffset() * 60

export function toQueryString(object: any): string {
  if (!object) return ''
  let query = Object.keys(object)
    .map((k: any) => `${k}=${object[k]}`)
    .join('&')
  if (query.length > 0) return `?${query}`
  return query
}

export function createFormData(
  platform: 'ios' | 'android' | 'web',
  body: any,
  file?: SendFile,
  //@ts-ignore
): any {
  //@ts-ignore
  const bodyFormData = new FormData()
  bodyFormData.append('query', JSON.stringify(body))
  if (file !== undefined) {
    if (platform === 'web') {
      throw new Error('Not implemented for web')
    }

    bodyFormData.append('image', {
      // @ts-ignore
      name: 'image',
      type: 'image/jpeg',
      uri: platform === 'ios' ? file.file.replace('file://', '') : file.file,
    })
  }
  return bodyFormData
}

export function isPOST(method: string | undefined, body: any): boolean {
  return method === 'POST' || (body !== undefined && method === undefined)
}

export function postHeaders(
  multipart: boolean,
  wrapInQuery: boolean = true,
): Record<string, string> {
  if (!wrapInQuery) {
    return {'Content-Type': 'application/json'}
  }
  return {
    'Content-Type': multipart
      ? 'multipart/form-data'
      : 'application/x-www-form-urlencoded',
  }
}

export async function postRequest(url: string, body: any, multipart = false) {
  return axios(url, {
    data: body,
    timeout: 10000,
    method: 'POST',
    headers: postHeaders(multipart),
  })
}

export const isStatusOk = (status?: number): boolean => {
  if (!status) return false
  return status >= 200 && status < 300
}
